import { useSelector } from 'react-redux';
import { RootState } from '../store';

export type UserRole = 'SUPER_ADMIN' | 'ADMIN' | 'INVENTORY_MANAGER' | 'VIEWER' | 'USER';

const ROLE_HIERARCHY: Record<string, number> = {
  SUPER_ADMIN: 5,
  ADMIN: 4,
  INVENTORY_MANAGER: 3,
  VIEWER: 2,
  USER: 1
};

export function usePermission() {
  const user = useSelector((state: RootState) => state.auth.user);
  const userRole = user?.role || 'USER';

  const hasAccess = (requiredRole: UserRole) => {
    const userValue = ROLE_HIERARCHY[userRole] || 1;
    const requiredValue = ROLE_HIERARCHY[requiredRole] || 1;
    return userValue >= requiredValue;
  };

  return {
    role: userRole as UserRole,
    hasAccess,
    isSuperAdmin: userRole === 'SUPER_ADMIN',
    isAdmin: userRole === 'ADMIN' || userRole === 'SUPER_ADMIN',
    isInventoryManager: userRole === 'INVENTORY_MANAGER' || userRole === 'ADMIN' || userRole === 'SUPER_ADMIN',
    isViewer: userRole === 'VIEWER' || userRole === 'INVENTORY_MANAGER' || userRole === 'ADMIN' || userRole === 'SUPER_ADMIN',
  };
}
